import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { api, json } from '../../lib/api';
import { PageHeader } from '../../components/PageHeader';
import { ErrorBanner } from '../../components/ErrorBanner';
import { FileUpload } from '../../components/FileUpload';
import { AddModal } from '../../components/AddModal';

export function LeadDetailPage() {
  const { id = '' } = useParams();
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ['lead', id], queryFn: () => api<any>(`/crm/leads/${id}`), enabled: Boolean(id) });
  const [note, setNote] = useState('');
  const [actionType, setActionType] = useState('CALL');
  const [actionNote, setActionNote] = useState('');
  const refresh = () => qc.invalidateQueries({ queryKey: ['lead', id] });
  const addNote = useMutation({ mutationFn: () => api(`/crm/leads/${id}/notes`, { method: 'POST', ...json({ companyId: q.data.companyId, body: note, visibility: 'INTERNAL' }) }), onSuccess: () => { setNote(''); refresh(); } });
  const addAction = useMutation({ mutationFn: () => api(`/crm/leads/${id}/actions`, { method: 'POST', ...json({ actionType, note: actionNote || null }) }), onSuccess: () => { setActionNote(''); refresh(); } });
  const attach = useMutation({ mutationFn: (fileId: string) => api(`/crm/leads/${id}/attachments`, { method: 'POST', ...json({ companyId: q.data.companyId, fileObjectId: fileId }) }), onSuccess: refresh });
  const x = q.data;

  return <section>
    <PageHeader title={x ? `${x.firstName} ${x.lastName ?? ''}` : 'Lead'} subtitle={x ? `${x.stage} • ${x.phone}` : 'Lead detail'} actions={x ? <>
      <AddModal title="Add lead action" buttonLabel="+ Add action" submitLabel="Add action" error={addAction.error} onSubmit={() => addAction.mutateAsync()}>
        <label>Action type<select value={actionType} onChange={e => setActionType(e.target.value)}><option>CALL</option><option>WHATSAPP</option><option>VISIT</option><option>FOLLOW_UP</option></select></label>
        <label className="span-two">Note<textarea value={actionNote} onChange={e => setActionNote(e.target.value)} rows={3} /></label>
      </AddModal>
      <AddModal title="Add internal note" buttonLabel="+ Add note" submitLabel="Add note" error={addNote.error} onSubmit={() => addNote.mutateAsync()}>
        <label className="span-two">Note<textarea value={note} onChange={e => setNote(e.target.value)} required rows={4} /></label>
      </AddModal>
      <AddModal title="Attach document" buttonLabel="+ Add document" showSubmit={false} error={attach.error}>
        <div className="span-two"><FileUpload companyId={x.companyId} onUploaded={file => attach.mutate(file.id)} /></div>
      </AddModal>
    </> : null} />
    <Link to="/crm/leads">← Back to leads</Link>
    <ErrorBanner error={q.error || addNote.error || addAction.error || attach.error} />
    {x && <>
      <div className="grid two">
        <div className="card"><h3>Contact</h3><dl><dt>Phone</dt><dd>{x.phone}</dd><dt>Email</dt><dd>{x.email || '—'}</dd><dt>Source</dt><dd>{x.source?.name || '—'}</dd><dt>Branch</dt><dd>{x.branchId}</dd></dl></div>
        <div className="card"><h3>Documents</h3>{x.attachments?.length ? x.attachments.map((a: any) => <div key={a.id}>{a.fileObject.fileName}</div>) : <p className="muted">No documents yet.</p>}</div>
      </div>
      <div className="grid two">
        <div className="card"><h3>Actions</h3>{x.actions?.map((a: any) => <div className="timeline" key={a.id}><strong>{a.actionType}</strong><span>{a.note}</span><small>{new Date(a.createdAt).toLocaleString()}</small></div>)}</div>
        <div className="card"><h3>Notes</h3>{x.notes?.map((n: any) => <div className="timeline" key={n.id}><strong>{n.visibility}</strong><span>{n.body}</span><small>{new Date(n.createdAt).toLocaleString()}</small></div>)}</div>
      </div>
    </>}
  </section>;
}
